import {textInput} from 'app/client/ui/inputs';
import {bigBasicButton as gristBigBasicButton,
        bigPrimaryButton as gristBigPrimaryButton,
        textButton as gristTextButton} from 'app/client/ui2018/buttons';
import {theme, vars} from 'app/client/ui2018/cssVars';
import {cssModalBody, cssModalButtons, cssModalTitle} from 'app/client/ui2018/modals';
import {styled} from 'grainjs';

export const text = styled('div', `
  color: ${theme.text};
  font-size: ${vars.mediumFontSize};
  border: none;
  padding: 0;
  text-align: left;
`);

export const input = styled(textInput, `
  height: 42px;
  line-height: 16px;
  padding: 13px;
  border-radius: 3px;
`);

export const codeInput = styled(input, `
  width: 200px;
`);

export const formLabel = styled('label', `
  display: inline-block;
  font-weight: bold;
  margin-bottom: 12px;
`);

export const formInstructions = styled(text, `
  margin-bottom: 32px;
`);

export const formError = styled(text, `
  color: ${theme.errorText};
  margin-bottom: 16px;
`);

const cssCenteredDiv = styled('div', `
  display: flex;
  justify-content: center;
  align-items: center;
`);

export const smallSpinner = cssCenteredDiv;

export const spinner = styled(cssCenteredDiv, `
  height: 200px;
  min-width: 200px;
`);

export const formHeading = cssModalTitle;

export const formButtons = cssModalButtons;

export const formBody = styled(cssModalBody, `
  margin: 16px 0px 0px 0px;
`);

export const formFooter = styled(text, `
  margin-top: 40px;
`);

export const resendCode = styled(text, `
  margin-top: 8px;
`);

/**
 * TODO: Consider using our own outline.
 *
 * We revert here to improve accessibility in forms. We could also
 * leave the default outline alone, since it doesn't seem to appear on
 * click anymore (in modern browsers, at least).
 */
export const bigPrimaryButton = styled(gristBigPrimaryButton, `
  outline: revert;
`);

export const bigBasicButton = styled(gristBigBasicButton, `
  outline: revert;
`);

export const textButton = styled(gristTextButton, `
  outline: revert;
`);
